module.exports = __webpack_public_path__ + "img/not-found.e48b5850.svg";